export enum DatePickerDayMonth {
  Previous = 'previous',
  Current = 'current',
  Next = 'next'
}
